import CompactEmptyState from 'components/EmptyState/CompactEmptyState';
import useHomeText from 'hooks/useHomeText';

// No task today: the clock of the empty states, in a dashed frame, and the
// button that adds one.
const TasksEmpty = ({ onAdd }) => {
  const { text } = useHomeText();
  return (
    <div className="rounded-lg border border-dashed border-gray-200 px-6">
      <CompactEmptyState
        compact
        glyph="clock"
        title={text('tasks.emptyTitle')}
        description={text('tasks.emptyText')}
        action={{ label: text('tasks.addTask'), onClick: onAdd }}
      />
    </div>
  );
};

export default TasksEmpty;
